import React from 'react';
import {formatTimestamps} from '../../../util/parseDate';

const timeSlot = (props) => {
  const [start, end] = formatTimestamps(props.start, props.end);

  return (
    <tr className="cursor-pointer" onClick={props.clicked}>
      <td className="text-center">{start}</td>
      <td className="text-center">{end}</td>
    </tr>
  );

};

export default timeSlot;